import { Category } from './../model/search-base-model';

export const emptyCategory: Category = {
  id: '0',
  value: "",
  displayText: 'All',
}

export const categoryFactory = (): { [key: string]: Category[] } => {

  return {
    productType: [
      {
        id: '1',
        value: 'window',
        displayText: 'Window',
      },
      {
        id: '2',
        value: 'door',
        displayText: 'Door',
      }
    ]
  }
};
